import { render, staticRenderFns } from "./jxsPrivacyPolicy.vue?vue&type=template&id=67be52e8&scoped=true"
import script from "./jxsPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./jxsPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./jxsPrivacyPolicy.vue?vue&type=style&index=0&id=67be52e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be52e8",
  null
  
)

export default component.exports